import { render, staticRenderFns } from "./Coberturas.vue?vue&type=template&id=311f44f8&"
import script from "./Coberturas.vue?vue&type=script&lang=js&"
export * from "./Coberturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports